export default __webpack_public_path__ + "static/media/gallery_08.6e9783b1.jpg";